(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const switchVariantImage = (card, mediaId) => {
      if (!mediaId || !card) return;

      const primary = card.querySelector('.hero-hotspot-card__image--primary');
      const variantImages = card.querySelectorAll('.hero-hotspot-card__image--variant');
      let hasActiveVariant = false;

      variantImages.forEach((img) => {
        const imgMediaId = img.dataset.mediaId;
        const shouldShow = String(imgMediaId) === String(mediaId);
        
        if (shouldShow) {
          img.classList.add('is-active');
          hasActiveVariant = true;
        } else {
          img.classList.remove('is-active');
        }
      });

      if (primary) {
        if (hasActiveVariant) {
          primary.classList.add('is-hidden');
        } else {
          primary.classList.remove('is-hidden');
        }
      }
    };

    const getSwatchMediaContext = (target) => {
      const label = target.closest('.hero-hotspot-card .variant-option__button-label[data-media-id]');
      if (label) {
        return {
          card: label.closest('.hero-hotspot-card'),
          mediaId: label.dataset.mediaId,
        };
      }

      const input = target.closest('.hero-hotspot-card .variant-option__button-label input[data-option-media-id]');
      if (input) {
        const inputLabel = input.closest('.variant-option__button-label');
        return {
          card: input.closest('.hero-hotspot-card'),
          mediaId: input.dataset.optionMediaId || inputLabel?.dataset.mediaId,
        };
      }

      return null;
    };

    // Handle both immediate pointer interaction and input-change fallback.
    const handleSwatchInteraction = (event) => {
      const context = getSwatchMediaContext(event.target);
      if (!context?.card || !context.mediaId) return;
      switchVariantImage(context.card, context.mediaId);
    };

    document.addEventListener('pointerdown', handleSwatchInteraction);
    document.addEventListener('change', handleSwatchInteraction, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
